import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import RoleBasedRoute from './components/RoleBasedRoute';
import HomeRedirect from './components/HomeRedirect';
import IcpFooter from './components/common/IcpFooter';

// --- 基础页面 ---
import Login from './pages/Login';

// --- 教研/管理后台页面 (原有的) ---
import DashboardPage from './pages/DashboardPage';
import CourseDetailPage from './pages/CourseDetailPage';
import WorkshopPage from './pages/WorkshopPage';
import SettingsPage from './pages/SettingsPage'; 
import WorkshopPlan from './pages/WorkshopPlan';
import AdminPage from './pages/AdminPage';
import UsersPage from './pages/UsersPage';
import UserLessonsPage from './pages/UserLessonsPage';
import LessonPublicPage from './pages/publish/LessonPublicPage';

// --- 一线看课平台页面 ---
// 假设您将这三个文件保存在 src/pages/student/ 目录下
import StudentPortal from './pages/student/StudentPortal';
import StudentLessonDetail from './pages/student/StudentLessonDetail'; // 对应上一轮对话中提供的详情页组件
import StudentSlidePlayer from './pages/student/StudentSlidePlayer';   // 对应上一轮对话中提供的播放器组件
import VibeCodingPage from './pages/student/vibe/VibeCodingPage';
import AiVexRedirectPage from './pages/student/AiVexRedirectPage';
import TokenManagementPage from './pages/admin/TokenManagementPage';
import ProgressTrackingPage from './pages/admin/ProgressTrackingPage';
import ChatRecordsAnalysisPage from './pages/admin/ChatRecordsAnalysisPage';
import AIInterfaceTestPage from './pages/admin/AIInterfaceTestPage';
import VibeCodingReclassifyPage from './pages/admin/GalleryAdminPage';
import UsageWarningPage from './pages/admin/UsageWarningPage';
import BatchPlanGenerationPage from './pages/admin/BatchPlanGenerationPage';



function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* Public: 登录页 */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected: 需要登录才能访问 */}
          <Route element={<PrivateRoute />}>
            
            {/* -----------------------------------------------------------------------
               区域 A: 教研与管理后台 (需要特定角色权限)
               只有 sys, admin, teacher 可以进入 Dashboard 及编辑页面
            ----------------------------------------------------------------------- */}
            <Route element={<RoleBasedRoute allowedRoles={['sys', 'admin', 'teacher']} />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/course/:courseId" element={<CourseDetailPage />} />
              <Route path="/workshop/ware/:stageId/:lessonId/:artifactId" element={<WorkshopPage />} />
              <Route path="/workshop/plan/:stageId/:lessonId/:artifactId" element={<WorkshopPlan />} />
              
              {/* 超级管理员区域 */}
              <Route element={<RoleBasedRoute allowedRoles={['sys']} />}>
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/admin/users" element={<UsersPage />} />
                <Route path="/admin/user-lessons" element={<UserLessonsPage />} />
                <Route path="/admin/lesson-public" element={<LessonPublicPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/admin/token-management" element={<TokenManagementPage />} />
                <Route path="/admin/progress-tracking" element={<ProgressTrackingPage />} />
                <Route path="/admin/chat-records-analysis" element={<ChatRecordsAnalysisPage />} />
                <Route path="/admin/ai-interface-test" element={<AIInterfaceTestPage />} />
                <Route path="/admin/vibe-coding-reclassify" element={<VibeCodingReclassifyPage />} />
                <Route path="/admin/usage-warning" element={<UsageWarningPage />} />
                <Route path="/admin/batch-plan-generation" element={<BatchPlanGenerationPage />} />
              </Route>
            </Route>

            {/* -----------------------------------------------------------------------
               区域 B: 一线看课平台 (Student Portal)
               只要登录即可访问 (包含学生、教师、管理员)
               注意：这里不加 RoleBasedRoute 限制，以便 view_only 权限的用户也能访问
            ----------------------------------------------------------------------- */}
            {/* 1. 酷炫的课程体系展示页 */}
            <Route path="/student/portal" element={<StudentPortal />} />
            
            {/* 2. 单课详情与 Slide 列表页 */}
            <Route path="/student/lesson/:lessonId" element={<StudentLessonDetail />} />
            
            {/* 3. 沉浸式课件播放器 */}
            <Route path="/student/lesson/:lessonId/slide/:slideId" element={<StudentSlidePlayer />} />
            
            // ...
            <Route path="/student/vibe-coding" element={<VibeCodingPage />} />
            <Route path="/student/ai-vex" element={<AiVexRedirectPage />} />


            {/* -----------------------------------------------------------------------
               默认路由处理
            ----------------------------------------------------------------------- */}
            {/* 
               注意：如果纯“学生”账号访问根路径 '/'，这里会尝试跳转去 /dashboard。
               如果 RoleBasedRoute 拦截了学生访问 /dashboard，可能会显示 403。
               为了用户体验，您可以考虑写一个自定义的 <HomeRedirect /> 组件来替代下面的 Navigate，
               根据用户权限决定跳往 dashboard 还是 student/portal。
               但基于当前需求，保留原状即可，因为 Login 页已经处理了首次跳转。
            */}
            <Route path="/" element={<HomeRedirect />} />

          </Route>
        </Routes>
        <IcpFooter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
